module.exports = __webpack_public_path__ + "img/logo - Copy (2).70c8ef27.png";